<template>
  <div style="position: relative;">
    <v-file-input
      ref="imageInput"
      label="Upload Image"
      accept="image/*"
      @change="onImageChange"
      class="d-none"
    ></v-file-input>
    <v-img
      @click="openFileDialog"
      @dragover.prevent="dragOver"
      @dragenter.prevent="dragEnter"
      @dragleave.prevent="dragLeave"
      @drop.prevent="onFileDrop"
      :src="previewSrc"
      contain
    />
    <v-btn v-if="showDownloadButton" fab style="position: absolute; z-index: 9999; right: 8px; top: 8px" small
      @click="downloadImage">
      <v-icon>mdi-cloud-download-outline</v-icon>
    </v-btn>
  </div>
</template>

<script>
  export default {
    props: {
      intialPreviewURL: String,
      showDownloadButton: Boolean,
    },
    data() {
      return {
        selectedImage: null,
        previewSrc: 'https://placehold.co/200x300',
        isDragOver: false,
      }
    },
    methods: {
      openFileDialog() {
        this.$refs.imageInput.$refs.input.click()
      },
      // Handlers remain mostly the same, but update isDragOver appropriately
      dragOver() {
        this.isDragOver = true
      },
      dragEnter() {
        this.isDragOver = true
      },
      dragLeave() {
        this.isDragOver = false
      },
      onFileDrop(e) {
        this.isDragOver = false // Reset on drop
        const files = Array.from(e.dataTransfer.files)
        if (files.length > 0) this.onImageChange(files[0])
      },
      onImageChange(file) {
        if (file) {
          this.selectedImage = file
          const reader = new FileReader()
          reader.onload = (e) => {
            this.previewSrc = e.target.result
          }
          reader.readAsDataURL(file)
          this.$emit('change', file)
        }
      },
      async downloadImage() {
        // Download the currently previewed image
        const link = document.createElement('a')
        link.href = this.previewSrc
        link.download = 'engraving_image.png'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
    },
    watch: {
      intialPreviewURL: {
        immediate: true,
        async handler(newVal) {
          if (newVal) {
            const response = await fetch(newVal)
            const blob = await response.blob()
            this.onImageChange(new File([blob], 'initialImage', { type: blob.type }))
          }
        },
      },
    },
  }
</script>

<style scoped></style>
